"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeoutError = void 0;
exports.default = promiseWithTimeout;
class TimeoutError extends Error {
    constructor({ message, timeout }) {
        super(message);
        this.name = "TimeoutError";
        this.timeout = timeout;
    }
}
exports.TimeoutError = TimeoutError;
/**
 * Simplified version of https://github.com/sindresorhus/p-timeout/blob/main/index.js
 */
function promiseWithTimeout(promise, milliseconds) {
    let timer;
    return new Promise((resolve, reject) => {
        if (typeof milliseconds !== "number" || Math.sign(milliseconds) !== 1) {
            throw new TypeError(`Expected \`milliseconds\` to be a positive number, got \`${milliseconds}\``);
        }
        timer = setTimeout.call(undefined, () => {
            const message = `Promise timed out after ${milliseconds} milliseconds`;
            const timeoutError = new TimeoutError({ message, timeout: milliseconds });
            reject(timeoutError);
        }, milliseconds);
        (() => __awaiter(this, void 0, void 0, function* () {
            try {
                resolve(yield promise);
            }
            catch (error) {
                reject(error);
            }
            finally {
                clearTimeout.call(undefined, timer);
            }
        }))();
    });
}
